// extracted by css-extract-rspack-plugin
export default {"label":"InlineData_label__k3cgt","clickable":"InlineData_clickable__qXrA8"};